var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"height":"90vh"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',{staticClass:"display-3 font-weight-bold"},[_vm._v("404")]),_c('p',{staticClass:"headline font-weight-bold"},[_vm._v("The page you want is not found")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }